<template lang="pug">
  .form-container
    .page-heading
      h1.page-title.page-title_top
        span(v-if="isInPasswordChangeMode")
          | Смена пароля
        span(v-else)
          | Мои данные
    form-agv-details(:customer="customerCopy"
    :errors="errors"
    :country-code="'ru'"
    :is-in-password-change-mode="isInPasswordChangeMode"
    :is-login-editable="false"
    :is-in-aggregator-mode="true")
    el-button(type="success" @click="onTrySave")
      | Сохранить
</template>

<script>
  import axios from 'axios'
  import _ from 'lodash'
  import Vue from 'vue'

  import FormAgvDetails from 'Aggregator/pages/form-agv-details'

  export default {
    name: 'page-agv-customer-details',
    components: {FormAgvDetails},
    props: {
      customer: Object
    },
    data() {
      return {
        errors: {},
        customerCopy: {},
        isInPasswordChangeMode: false
      }
    },
    methods: {
      onTrySave() {
        this.$store.dispatch('customer/save', {customer: this.customerCopy})
          .catch((error) => {
            Vue.set(this, 'errors', error.response.data)
          })
      },
      onCustomerChange() {
        this.customerCopy = _.clone(this.customer)
      }
    },
    watch: {
      customer: {
        handler: 'onCustomerChange',
        immediate: true
      }
    }
  }
</script>

<style scoped>
</style>
